"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const Flex_1 = tslib_1.__importDefault(require("./Elements/Flex"));
const ClickedOutside_1 = tslib_1.__importDefault(require("./ClickedOutside"));
const defaultProps = {
    isOpen: false,
    shouldCloseWhenClickOutside: true,
    shouldCloseWhenEsc: true,
    blackOverlay: false,
};
const initialState = {};
const Container = (0, styled_components_1.default)(Flex_1.default) `
  position: fixed;
  justify-content: center;
  align-items: center;
  background: ${props => props.blackOverlay ? 'rgba(39, 39, 39, 0.7)' : 'rgba(255, 255, 255, 0.7)'};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000000;
`;
const ModalContent = (0, styled_components_1.default)(Flex_1.default) ``;
class Modal extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
    }
    componentDidUpdate() {
        // * LOC bellow will prevent body scrolling
        // * when modal openned
        const { isOpen } = this.props;
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.removeAttribute('style');
        }
    }
    render() {
        const { isOpen, onRequestToClose, blackOverlay } = this.props;
        if (!isOpen) {
            return null;
        }
        return (react_1.default.createElement(ClickedOutside_1.default, { shouldHandleClick: isOpen, onClickOutside: onRequestToClose }, ({ ref }) => (react_1.default.createElement(Container, { blackOverlay: blackOverlay },
            react_1.default.createElement(ModalContent, { ref: ref }, this.props.children)))));
    }
}
exports.default = Modal;
Modal.defaultProps = defaultProps;
